import React from "react";
import SvgIcon from "../SvgIcon";

export const GymLocationMobile = ({
  gymLocations = [],
  onDelete = () => {},
  onEdit = () => {},
  onTimingModal = () => {},
}) => {
  return (
    <div className="gym-locations-wrapper only-show-mobile">
      {gymLocations.map((item, index) => {
        return (
          <div
            className="gym-location-table-content"
            key={
              item.gymName && item.facilikey
                ? `${item.gymName}-${item.facilikey}`
                : index
            }
          >
            <div className="content">
              <header>
                <span>Gym Name</span>
                <span>Location</span>
                <span>Google Maps Link</span>
                <span>Facilikey</span>
              </header>
              <div className="gym-info">
                <span>{item.gymName ? item.gymName : ""}</span>
                <span>{item.gymLocation ? item.gymLocation : ""}</span>
                <span>{item.gymMapLink ? item.gymMapLink : ""}</span>
                <span>{item.facilikey ? item.facilikey : ""}</span>
              </div>
            </div>

            <div className="action-buttons">
              <button
                onClick={(e) => {
                  onEdit(e, item.gymCoordinates, item.gymContact);
                }}
                data-button-type="primary"
                data-icon
                data-icon-only
              >
                <SvgIcon
                  src={"/img/new-icons/edit-pencil.svg"}
                  noFilterOnLight={true}
                />
                Edit
              </button>
              <button
                data-button-type="secondary"
                data-icon
                data-icon-only
                onClick={(e) => {
                  onTimingModal(e, item.gymCoordinates, item.gymContact);
                }}
              >
                <img
                  src="/img/svg/time.svg"
                  width={15}
                  height={15}
                  alt="time"
                />
              </button>
              <button
                data-button-type="secondary"
                data-icon
                data-icon-only
                onClick={(event) => {
                  onDelete(event, index);
                }}
              >
                <img
                  src="/img/new-icons/red-trash.svg"
                  width={15}
                  height={15}
                  alt="delete"
                />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
